import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  fetchData,
  urls,
} from '@internal/backstage-plugin-dh-dock-shared-common';

export type productProps = {
  resolvedname: string;
  entity_ref: string;
  productentity: string;
};
export interface processedProductsProps {
  processProducts: productProps[];
  loading: boolean;
  error: string | null;
}

const initialState: processedProductsProps = {
  processProducts: [],
  loading: false,
  error: null,
};

export const fetchProcessedProductsAsync = createAsyncThunk(
  'products/processedProducts',
  async () => {
    const response = await fetchData(urls.getProcessedProducts);
    return response;
  },
);
const ProductSlice = createSlice({
  name: 'processedProducts',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder

      .addCase(fetchProcessedProductsAsync.pending, state => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchProcessedProductsAsync.fulfilled, (state, action) => {
        state.processProducts = action.payload;
        state.loading = false;
      })

      .addCase(fetchProcessedProductsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch products';
      });
  },
});

export default ProductSlice.reducer;
